import { createReducer, on } from "@ngrx/store";
import {
  resetInPageNavigation,
  setAudienceNavigation,
  setBaseHref,
  setCurrentBusinessUnit,
  setCurrentPageId,
  setCurrentPageTitle,
  setFilterByCategory,
  setSearchType,
  setInPageNavigation,
  setMainNavMobileOpen,
  setMainNavOpen,
  setPageType,
  setTrustPilot,
  setWindowLoaded,
  setYoutubeScriptLoaded,
  setInLineContentIdList,
  removeInLineContentId,
  setActiveLanguage
} from "./global.actions";

// this interface is here to avoid TS error when using a string to access object keys
// this error would have appeared in the text block when dynamically loading the content area layout
interface IObjectKeys {
  [key: string]: any;
}

export interface GlobalState extends IObjectKeys {
  baseHref: string;
  inPageNav: any;
  filterCategory: number | null;
  pageSearchType: string;
  pageTitle: string;
  pageId: number | null;
  businessUnit: string;
  youtubeScriptLoaded: boolean;
  trustPilot: { scriptLoaded: boolean; blockId: string; trustPilotData: any };
  audienceNavigation: [any] | undefined;
  isMainNavMobileOpen: boolean;
  isMainNavOpen: boolean;
  pageType: string;
  windowLoaded: boolean;
  inLineContentIdList: Array<string>;
  activeLanguage: {lang: string, name: string};
}

export const initialState: GlobalState = {
  baseHref: "",
  inPageNav: [],
  filterCategory: null,
  pageSearchType: "",
  pageId: null,
  pageTitle: "",
  businessUnit: "",
  youtubeScriptLoaded: false,
  trustPilot: { scriptLoaded: false, blockId: "", trustPilotData: {} },
  audienceNavigation: undefined,
  isMainNavMobileOpen: false,
  isMainNavOpen: false,
  pageType: "",
  windowLoaded: false,
  inLineContentIdList: [],
  activeLanguage: { lang: "en", name: "English"}
};

export const globalReducer = createReducer(
  initialState,
  on(setBaseHref, (state, { url }) => {
    return {
      ...state,
      baseHref: url
    };
  }),
  on(setActiveLanguage, (state, { lang, name }) => {
    return {
      ...state,
      activeLanguage: {lang, name}
    };
  }),
  on(setInPageNavigation, (state, { item }) => {
    return {
      ...state,
      inPageNav: [...state.inPageNav, item]
    };
  }),
  on(resetInPageNavigation, (state) => {
    return {
      ...state,
      inPageNav: []
    };
  }),
  on(setFilterByCategory, (state, { category }) => {
    return {
      ...state,
      filterCategory: category
    };
  }),
  on(setSearchType, (state, { searchType }) => {
    return {
      ...state,
      pageSearchType: searchType
    };
  }),
  on(setCurrentPageId, (state, { pageId }) => {
    return {
      ...state,
      pageId: pageId
    };
  }),
  on(setCurrentPageTitle, (state, { pageTitle }) => {
    return {
      ...state,
      pageTitle: pageTitle
    };
  }),
  on(setCurrentBusinessUnit, (state, { businessUnit }) => {
    return {
      ...state,
      businessUnit: businessUnit
    };
  }),
  on(setYoutubeScriptLoaded, (state, { youtubeScriptLoaded }) => {
    return {
      ...state,
      youtubeScriptLoaded: youtubeScriptLoaded
    };
  }),
  on(setTrustPilot, (state, { scriptLoaded, blockId, trustPilotData }) => {
    return {
      ...state,
      trustPilot: { scriptLoaded, blockId, trustPilotData }
    };
  }),
  on(setAudienceNavigation, (state, { nav }) => {
    return {
      ...state,
      audienceNavigation: nav
    };
  }),
  on(setMainNavMobileOpen, (state, { open }) => {
    return {
      ...state,
      isMainNavMobileOpen: open
    };
  }),
  on(setMainNavOpen, (state, { open }) => {
    return {
      ...state,
      isMainNavOpen: open
    };
  }),
  on(setPageType, (state, { pageType }) => {
    return {
      ...state,
      pageType: pageType
    };
  }),
  on(setWindowLoaded, (state, { windowLoaded }) => {
    return {
      ...state,
      windowLoaded
    };
  }),
  on(setInLineContentIdList, (state, { inLineContentIdList }) => {
    return {
      ...state,
      inLineContentIdList: inLineContentIdList
    };
  }),
  on(removeInLineContentId, (state, { inLineContentId }) => {
    return {
      ...state,
      inLineContentIdList: state.inLineContentIdList.filter(
        (e) => e !== inLineContentId
      )
    };
  })
);
